// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__R0IM5","row":"styles_row__b0i9d","column":"styles_column__zfGm8"};